var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nice-tree-demo",class:{
		'root-list': _vm.depth === 0,
	},style:({
		'--depth': _vm.depth,
	})},_vm._l((_vm.list),function(entry){return _c('li',{key:("entry-" + (entry.value)),staticClass:"entry",class:{
			'selected': _vm.value.includes(entry.value),
		}},[_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm._f("capitalize")(entry.label)))]),(!_vm.value.includes(entry.value))?_c('nice-tree-demo',{attrs:{"tree":_vm.filteredTree,"depth":_vm.depth + 1,"value":_vm.value,"entry-point":entry.value}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }